<template>
	<div class="related-tasks" :class="{ 'related-tasks--expanded': relatedExpanded || !isExpandable}">
		<template v-if="tasks.length">
			<template v-if="activeTasks.length">
				<related-tasks-list :tasks="activeTasks" :relatedOnly="true" />
			</template>

			<template v-if="(archivedTasks.length) || !activeTasks.length">
				<strong v-if="activeTasks.length">{{ archivedTasks.length }} Archived {{ pluralizeString }}:</strong>
				
				<related-tasks-list :tasks="archivedTasks" :archivedOnly="true" :relatedOnly="activeTasks.length ? false : true" />
				
				<button v-if="isExpandable && !relatedExpanded" type="button" class="button" @click="showRelated">
					<i class="icon icon-chevrons-expand"></i>
					
					Show all archived tasks
				</button>
			</template>
		</template>

		<div v-if="isLoading" class="related-tasks__message">
			Loading related Tasks
		</div>

		<div v-if="hasNoResults" class="related-tasks__message">
			No related tasks were found.
		</div>

		<div v-if="isForbidden" class="related-tasks__message">
			Login in <a :href="tasksUrl" target="_blank">tasks</a> to see list of related tasks here.
		</div>

		<div v-if="hasFailed" class="related-tasks__message">
			An error has occured during related tasks fetching.
		</div>
	</div>
</template>

<script>
import { pluralize } from '../filters';
import Loading from '../components/Loading.vue';
import RelatedTasksList from '../components/RelatedTasksList.vue';

export default {
	name: 'app-related-tasks',

	components: {
		Loading,
		RelatedTasksList,
	},

	data() {
		return {
			status: 'loading',
			relatedExpanded: false,
			tasks: [],
		};
	},

	computed: {
		/**
		 * Get tasksUrl from $root dataSet
		 * @return {String}
		 */
		tasksUrl() {
			return this.$root.dataSet && this.$root.dataSet.tasksUrl;
		},

		/**
		 * Get projec token from $root dataSet
		 * @return {String}
		 */
		token() {
			return this.$root.dataSet && this.$root.dataSet.token;
		},

		/**
		 * Whether widget is loading
		 * @return {Boolean}
		 */
		isLoading() {
			return this.status === 'loading';
		},


		/**
		 * Whether widget no related tasks results were found
		 * @return {Boolean}
		 */
		hasNoResults() {
			return this.status === 'loaded' && !this.tasks.length;
		},

		/**
		 * Whether widget has failed with forbidden status
		 * @return {Boolean}
		 */
		isForbidden() {
			return this.status === 'forbidden';
		},

		/**
		 * Whether widget has generally failed during tasks fetch
		 * @return {Boolean}
		 */
		hasFailed() {
			return this.status === 'failed';
		},

		/**
		 * Get all active tasks
		 * @return {Array}
		 */
		activeTasks() {
			return this.tasks.filter(task => !task.is_archived);
		},

		/**
		 * Get all archived tasks
		 * @return {Array}
		 */
		archivedTasks() {
			return this.tasks.filter(task => task.is_archived);
		},

		/**
		 * Get all task satellites.
		 * @return {Array}
		 */
		satellites() {
			return (this.tasks || [])
				.map(task => task.satellite)
				.filter((satellite, index, array) => satellite && array.indexOf(satellite) === index);
		},

		/**
		 * Checks if there are enough archived for expanding
		 * @return {Boolean}
		 */
		isExpandable() {
			return this.archivedTasks.length > 3
		},

		pluralizeString() {
			return pluralize('Task', this.archivedTasks.length)
		}
	},

	methods: {
		/**
		 * Initialize related tasks app
		 * @return {Void}
		 */
		init() {
			this.load()
				.then(res => {
					this.status = 'loaded';
					this.tasks = res;

					$eventDispatcher.$emit('satellites:loaded', this.satellites);

					this.resizeHolder();
				})
				.catch(err => {
					if (err.status === 403) {
						this.status = 'forbidden';
					} else {
						this.status = 'failed';
					}

					this.tasks = [];
				});
		},

		/**
		 * Show the related tasks
		 * @return {void}
		 */
		showRelated() {
			this.relatedExpanded = true;
		},

		/**
		 * Load related tasks load
		 * @return {Promise}
		 */
		load() {
			return $.ajax({
				type: 'GET',
				url: `/api/get-related-tasks?project_token=${this.token}`,
				dataType: 'json'
			});
		},

		/**
		 * Resize sidebar-box holder in sidebar
		 * @return {Void}
		 */
		resizeHolder() {
			const $parent = $(this.$el).closest('#related-tasks-box');
			const $holder = $parent.prev().filter('.sp-holder');

			if ($holder.length) {
				setTimeout(() => {
					$holder.height($parent.outerHeight(false));
				}, 100);
			}
		},

		/**
		 * Show hidden tasks
		 * @return {Void}
		 */
		showHiddenTasks() {
			this.resizeHolder();
		},

		/**
		 * Emit related tasks updated event.
		 * @return {void}
		 */
		emitUpdated() {
			if (window.$eventDispatcher) {
				window.$eventDispatcher.$emit('relatedTasks:updated');
			}
		},
	},

	created() {
		this.init();
	},

	updated() {
		this.emitUpdated();
	},
}
</script>
